import { isEmpty } from 'lodash';
import electionApi from '~/clientApis/electionApi';
import { showMessageModal } from '~/clientUtils/showMessageModal';
import { UpdateSettingsProps } from '~/definitions/generalSettings';
import { getStore } from '~/mobx/AppStore';

const assignToElectionSettingsData = async (params: { electionId: string; data: UpdateSettingsProps[] }) => {
    const { generalSettingsStore } = getStore();

    try {
        const result = await electionApi.assignToElectionSettings({ ...params });
        if (result.success) {
            generalSettingsStore.updateElectionAttributeData(params.data);
        }
    } catch (error) {
        showMessageModal('error', 'Error assigning election data');
        throw error;
    } finally {
        generalSettingsStore.setIsUpdatingRegionData(false);
    }
};

const updateElectionData = async () => {
    const { generalSettingsStore } = getStore();
    const { companyElectionData, selectedElectionId } = generalSettingsStore;

    generalSettingsStore.setIsUpdatingElectionData(true);

    const data: UpdateSettingsProps[] = [];
    const dataToAssign: UpdateSettingsProps[] = [];
    if (!isEmpty(companyElectionData)) {
        companyElectionData?.forEach((item) => {
            const attr = {
                id: item?.id || '',
                value: item?.value || '',
                type: item?.type || '',
            };
            if (!item.isAttributeAssigned) {
                dataToAssign.push({ ...attr });
            }
            data.push({ ...attr });
        });
    }

    if (!isEmpty(dataToAssign)) {
        assignToElectionSettingsData({ electionId: selectedElectionId, data: dataToAssign });
    }

    try {
        const result = await electionApi.updateElectionSettings({ electionId: selectedElectionId, data });
        if (result.success) {
            generalSettingsStore.updateElectionAttributeData();
        }
    } catch (error) {
        showMessageModal('error', 'Error updating election data');
        throw error;
    } finally {
        generalSettingsStore.setIsUpdatingElectionData(false);
    }
};

export default updateElectionData;
